import { cB as e, cM as r, cE as o, c as a, cNotM as t } from "./ghl-ui.es384.js";
const n = e("radio", `
 line-height: var(--n-label-line-height);
 outline: none;
 position: relative;
 user-select: none;
 -webkit-user-select: none;
 display: inline-flex;
 align-items: flex-start;
 flex-wrap: nowrap;
 font-size: var(--n-font-size);
 word-break: break-word;
`, [r("checked", [o("dot", `
 background-color: var(--n-color-active);
 `)]), o("dot-wrapper", `
 position: relative;
 flex-shrink: 0;
 flex-grow: 0;
 width: var(--n-radio-size);
 `), e("radio-input", `
 position: absolute;
 border: 0;
 border-radius: inherit;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 opacity: 0;
 z-index: 1;
 cursor: pointer;
 `), o("dot", `
 position: absolute;
 top: 50%;
 left: 0;
 transform: translateY(-50%);
 height: var(--n-radio-size);
 width: var(--n-radio-size);
 background: var(--n-color);
 box-shadow: var(--n-box-shadow);
 border-radius: 50%;
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 `, [a("&::before", `
 content: "";
 opacity: 0;
 position: absolute;
 left: 4px;
 top: 4px;
 height: calc(100% - 8px);
 width: calc(100% - 8px);
 border-radius: 50%;
 transform: scale(.8);
 background: var(--n-dot-color-active);
 transition: 
 opacity .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 transform .3s var(--n-bezier);
 `), r("checked", {
  boxShadow: "var(--n-box-shadow-active)"
}, [a("&::before", `
 opacity: 1;
 transform: scale(1);
 `)])]), o("label", `
 color: var(--n-text-color);
 padding: var(--n-label-padding);
 font-weight: var(--n-label-font-weight);
 display: inline-block;
 transition: color .3s var(--n-bezier);
 `), t("disabled", `
 cursor: pointer;
 `, [a("&:hover", [o("dot", {
  boxShadow: "var(--n-box-shadow-hover)"
})]), r("focus", [a("&:not(:active)", [o("dot", {
  boxShadow: "var(--n-box-shadow-focus)"
})])])]), r("disabled", `
 cursor: not-allowed;
 `, [o("dot", {
  boxShadow: "var(--n-box-shadow-disabled)",
  backgroundColor: "var(--n-color-disabled)"
}, [a("&::before", {
  backgroundColor: "var(--n-dot-color-disabled)"
}), r("checked", `
 opacity: 1;
 `)]), o("label", {
  color: "var(--n-text-color-disabled)"
}), e("radio-input", `
 cursor: not-allowed;
 `)])]);
export {
  n as default
};
